import { fetchRetryParameters, requestHostHeaders } from '~/composables/constants/api'
import type { RequestHostHeadersType } from '~/composables/constants/api'

export default async function (newLocale: string) {
  try {
    await $fetch('/api/locale/change', {
      method: 'POST',
      body: {
        newLocale,
      },
      ...fetchRetryParameters,
      headers: useRequestHeaders<RequestHostHeadersType>(requestHostHeaders),
      retry: 2,
      timeout: 1000,
    })
  } catch (e) {
    console.error(e)
  }
}
